import type { ComponentType, LazyExoticComponent } from 'react';

export interface SectionProps {
    applicationId: string;
    stageId: string;
    jobId: string;
    resultId?: string;
}

export interface SectionRegistration {
    stageType: string;
    label: string;
    icon?: ComponentType<{ className?: string }>;
    component: LazyExoticComponent<ComponentType<SectionProps>>;
    supportsMultipleResults: boolean;
}

const sectionRegistry = new Map<string, SectionRegistration>();

export function registerSection(reg: SectionRegistration) {
    sectionRegistry.set(reg.stageType, reg);
}

export function getSection(stageType: string): SectionRegistration | undefined {
    return sectionRegistry.get(stageType);
}

export function getAllSections(): Map<string, SectionRegistration> {
    return sectionRegistry;
}
